// extracted by mini-css-extract-plugin
var _1 = "plans-tag__wXbo3";
export { _1 as "plansTag" }
